"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateRotations = exports.postProcessingMarksForRotations = exports.correctMarks = exports.GenerationContext = void 0;
var moment_timezone_1 = __importDefault(require("moment-timezone"));
var GenerationService_1 = __importDefault(require("./services/GenerationService"));
var adCampaigns_1 = require("./services/adCampaigns");
var utils_1 = require("./services/adCampaigns/utils");
var mediafiles_1 = require("./services/mediafiles");
var MediafileGeneratorMediafileFilter_1 = require("./services/mediafiles/utils/MediafileGeneratorMediafileFilter");
var utils_2 = require("./utils");
var GenerationContext = (function () {
    function GenerationContext(startTime, timezone, lastRotations, targetLength, logger, tracing, endTime) {
        this.resultRotations = [];
        this.lastRotationGenerated = null;
        this.generationStart = null;
        this.timezone = timezone;
        this.nextTime = moment_timezone_1.default.parseZone(startTime).tz(timezone);
        if (endTime) {
            this.endTime = moment_timezone_1.default.parseZone(endTime).tz(timezone);
        }
        this.lastRotations = lastRotations.sort(function (prev, curr) {
            return (0, moment_timezone_1.default)(prev.playtime).isBefore((0, moment_timezone_1.default)(curr.playtime)) ? -1 : 1;
        });
        this.targetLength = targetLength;
        this.logger = logger;
        this.tracing = tracing;
    }
    GenerationContext.prototype.reachedTargetLength = function () {
        if (this.endTime) {
            return this.endTime.isSameOrBefore(this.nextTime);
        }
        return this.resultRotations.length >= this.targetLength;
    };
    GenerationContext.prototype.setGenerationStart = function () {
        this.generationStart = Date.now();
    };
    GenerationContext.prototype.getCurrentPlaylistLength = function () {
        return this.resultRotations.length;
    };
    GenerationContext.prototype.getNextTime = function () {
        return this.nextTime;
    };
    GenerationContext.prototype.addRotation = function (rotation, nextTime) {
        var _a;
        var now = Date.now();
        this.tracing &&
            ((_a = this.logger) === null || _a === void 0 ? void 0 : _a.debug("Added new rotation to playlist", {
                rotation: rotation,
                nextTime: nextTime,
                took: this.lastRotationGenerated
                    ? now - this.lastRotationGenerated
                    : now - this.generationStart,
            }));
        this.lastRotationGenerated = now;
        this.nextTime = nextTime;
        this.resultRotations.push(rotation);
    };
    GenerationContext.prototype.revertRotation = function () {
        var _a;
        var reverted = this.resultRotations.pop();
        this.tracing &&
            ((_a = this.logger) === null || _a === void 0 ? void 0 : _a.debug("Reverted rotation from playlist", {
                reverted: reverted,
            }));
        this.nextTime = (reverted === null || reverted === void 0 ? void 0 : reverted.playtime) ? reverted.playtime : this.nextTime;
    };
    return GenerationContext;
}());
exports.GenerationContext = GenerationContext;
function correctMarks(playlistItems) {
    return GenerationService_1.default.correctMarks(playlistItems);
}
exports.correctMarks = correctMarks;
function postProcessingMarksForRotations(rotations) {
    return GenerationService_1.default.postProcessingMarksForRotations(rotations);
}
exports.postProcessingMarksForRotations = postProcessingMarksForRotations;
function generateRotations(settings, options, setAdGenerationContext) {
    var _a, _b, _c;
    return __awaiter(this, void 0, void 0, function () {
        var logger, tracing, start, mediafiles, context, lastRotationIds, mediafileFilter, mediafileGenerator, adMediafileFilter, adGenerator;
        return __generator(this, function (_d) {
            logger = options === null || options === void 0 ? void 0 : options.logger;
            tracing = (_a = options === null || options === void 0 ? void 0 : options.tracing) !== null && _a !== void 0 ? _a : false;
            start = Date.now();
            tracing && (logger === null || logger === void 0 ? void 0 : logger.warn("Started generation", { start: start }));
            mediafiles = (0, utils_2.shuffleArrayBySeed)(settings.mediafiles, (0, moment_timezone_1.default)(settings.startTime).milliseconds().toString());
            context = new GenerationContext(settings.startTime, settings.timezone, settings.lastRotations, settings.numberMediafiles, logger, tracing, settings.endTime);
            lastRotationIds = settings.lastRotations.map(function (rotation) { return rotation.mediafileId; });
            mediafileFilter = new MediafileGeneratorMediafileFilter_1.MediafileGeneratorMediafileFilter((_b = settings.availableMediafileIds) !== null && _b !== void 0 ? _b : mediafiles.map(function (mf) { return mf.id; }), lastRotationIds);
            mediafileGenerator = new mediafiles_1.MediafileGenerator(settings.allBlocks, settings.stream.blockPattern, mediafileFilter.filter(mediafiles), settings.mediafileBlocks, settings.silentMediafile, settings.dislikedMediafiles, settings.rotatedMediafiles, settings.onetooneSeparate, settings.crossfade, settings.lastRotations, logger, tracing);
            adMediafileFilter = new utils_1.AdCampaignMediafileFilter((_c = settings.availableMediafileIds) !== null && _c !== void 0 ? _c : mediafiles.map(function (mf) { return mf.id; }));
            adGenerator = new adCampaigns_1.AdCampaignGenerator({
                adCampaigns: adMediafileFilter.filter(settings.adcampaigns),
                timezone: settings.timezone,
                startTime: settings.startTime,
                logger: logger,
                tracing: tracing,
                pattern: settings.pattern,
                cutDuration: settings.cutDuration,
            });
            setAdGenerationContext === null || setAdGenerationContext === void 0 ? void 0 : setAdGenerationContext(adGenerator);
            context.setGenerationStart();
            while (!context.reachedTargetLength()) {
                tracing &&
                    (logger === null || logger === void 0 ? void 0 : logger.debug("Generating rotation", {
                        current: context.getCurrentPlaylistLength(),
                        target: settings.numberMediafiles,
                    }));
                adGenerator.generate(context);
                if (!context.reachedTargetLength()) {
                    mediafileGenerator.generate(context);
                }
            }
            tracing && (logger === null || logger === void 0 ? void 0 : logger.warn("Ended generation", { start: start, took: Date.now() - start }));
            return [2, context.resultRotations];
        });
    });
}
exports.generateRotations = generateRotations;
//# sourceMappingURL=generateRotations.js.map